import { render, staticRenderFns } from "./FinalScore.vue?vue&type=template&id=46af2c64&scoped=true&"
import script from "./FinalScore.vue?vue&type=script&lang=js&"
export * from "./FinalScore.vue?vue&type=script&lang=js&"
import style0 from "./FinalScore.vue?vue&type=style&index=0&id=46af2c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46af2c64",
  null
  
)

component.options.__file = "FinalScore.vue"
export default component.exports